import { Separator as HySeparatorProps } from '@/lib/types';

import Separator from '@/components/separator';

import separatorTransformer from '@/hygraph/transformers/separator.transformer';

export default function SeparatorRenderer(props: unknown) {
  const componentProps = separatorTransformer(props as HySeparatorProps);
  return <Separator {...componentProps} />;
}
